import React from 'react';

import { di } from 'react-magnetic-di';

import type { Payload } from '@atlaskit/rovo-triggers/types';
import type { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { ActionRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

import { UpdateAgentBase } from '../update-agent-base';

export const UpdateAgentConfigurationAction = (
	actionRenderer: ActionRendererFor<typeof ActionKeys.UpdateAgentConfigurationTool>,
): React.JSX.Element => {
	di();

	const { ari } = actionRenderer.actions[0].data;
	const payload: Payload = {
		type: 'agent-configuration-update',
		data: {
			ari,
		},
		source: 'update-agent-configuration-action-ui',
	};

	return <UpdateAgentBase actionRenderer={actionRenderer} payload={payload} />;
};
